import type { ResolveItemNumbersResponse } from '@erp/rpc';
import { rowModeOf } from '@erp/item-master-rules';
import type { PendingEditsByRowKey } from '../as400ExportEditState';

const ITEMNO = 'ITEMNO';

// The ITEMNO rules themselves (format, collision) live in
// @erp/item-master-rules; what's here reads the grid's unsaved edits.
export {
  itemNumberCollisionRule,
  itemNumberFormatRule,
} from '@erp/item-master-rules';

export function pendingAddItemNumbers(
  pendingByScope: ReadonlyMap<string, PendingEditsByRowKey>,
): string[] {
  const numbers: string[] = [];
  for (const pending of pendingByScope.values()) {
    for (const edit of pending.values()) {
      if (rowModeOf(edit.rowKey) !== 'add') continue;
      const item = edit.values[ITEMNO];
      if (item) numbers.push(item);
    }
  }
  return numbers;
}

const EMPTY_TAKEN_ITEM_NUMBERS: ReadonlySet<string> = new Set();

export function takenItemNumbersOf(
  resolution: ResolveItemNumbersResponse | undefined,
): ReadonlySet<string> {
  if (resolution === undefined) return EMPTY_TAKEN_ITEM_NUMBERS;
  const taken = new Set<string>();
  for (const match of resolution.matched) {
    const sku = match.displaySku.trim().toUpperCase();
    if (sku !== '') taken.add(sku);
  }
  return taken;
}

export function itemNumberLookupBlocksSave(
  addItemNumbers: readonly string[],
  lookup: { isPending: boolean; isError: boolean },
): boolean {
  return addItemNumbers.length > 0 && (lookup.isPending || lookup.isError);
}
